import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CheckboxCheckedIcon = props => {
  return (
    <Svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M4.317.769a42.502 42.502 0 019.366 0c1.16.13 2.177.756 2.82 1.666L8.5 10.44 6.03 7.97A.75.75 0 004.97 9.03l3 3a.75.75 0 001.06 0l8.116-8.115c.022.11.04.22.053.333.37 3.157.37 6.346 0 9.503-.215 1.837-1.69 3.276-3.516 3.48a42.511 42.511 0 01-9.366 0C2.49 17.027 1.015 15.588.8 13.751a40.902 40.902 0 010-9.503C1.015 2.411 2.49.973 4.317.768z"
        fill="#3876AA"
      />
    </Svg>
  );
};

export default CheckboxCheckedIcon;
